// used to delay the execution of a function to the next event loop.
// Allows the browser to update the UI before the function is executed.
export function yieldToMain(cb) {
    if (!cb) return;
    return new Promise((resolve) => {
        setTimeout(() => {
            cb();
            resolve();
        }, 0);
    });
}
